<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">
        {{ modalLabel }}
      </div>
    </h2>

    <button type="button" class="closeModal" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="processingCustomConversionAddEditForm">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="
                processingCustomConversionAddEditForm.get('region')?.value ||
                processingCustomConversionAddEditForm.get('conversion')?.value
              "
              class="sub-header-drpdown pb-2"
              >Custom conversion</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #conversion
              [items]="processingCustomConversionList"
              [searchable]="false"
              bindValue="id"
              bindLabel="description"
              formControlName="conversion"
              [readonly]="isDisabledDropDown"
              [searchFn]="commonInputSearch"
              placeholder="Custom conversion *"
              groupBy="childItems"
              (change)="onChange($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="conversion.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback"><i class="fa fa-search icon"></i></span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item?.description }}
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.description }}">
                  {{ item.description }}
                </div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                submitted || processingCustomConversionAddEditForm.controls['conversion']?.touched
              "
              class="input-error"
            >
              <div *ngIf="processingCustomConversionAddEditForm.controls['conversion']?.invalid">
                Process name is required.
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="
                processingCustomConversionAddEditForm.get('region')?.value ||
                processingCustomConversionAddEditForm.get('conversion')?.value
              "
              class="sub-header-drpdown pb-2"
              >Region</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #region
              [items]="regionData"
              [searchable]="false"
              bindLabel="name"
              formControlName="region"
              [readonly]="isDisabledDropDown"
              [searchFn]="commonInputSearchForRegion"
              placeholder="Region *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="region.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (processingCustomConversionAddEditForm.controls['region']?.touched &&
                  processingCustomConversionAddEditForm.controls['region']?.invalid) ||
                processingCustomConversionAddEditForm.controls['region'].value?.name ===
                  '--Select region-- ' ||
                (submitted && !processingCustomConversionAddEditForm.controls['region'].value?.name)
              "
              class="input-error"
            >
              Region is required.
            </div>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="processingCustomConversionForm">
      <div class="row">
        <div class="col-sm-4" *ngFor="let formData of indicatorList">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input
                [formControlName]="formData.name"
                type="number"
                placeholder="{{ formData.name }} {{ formData.unit }}"
                maxlength="30"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              />
              <label>{{ formData.name }} ({{ formData.unit }})</label>
              <div *ngIf="submitted && processingCustomConversionForm.get(formData.name)?.invalid">
                <div class="input-error">Default value is required</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="setButtonAndError text-margin">
        <div class="modal-footer">
          <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
          <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">
            Save
          </button>
        </div>

        <div
          class="redErrorTag"
          *ngIf="
            submitted &&
            (this.processingCustomConversionAddEditForm.invalid ||
              processingCustomConversionForm.invalid)
          "
        >
          <div class="bigScreenErrContain">
            <div>
              <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
            </div>
            <div>
              <div class="mb-3">
                <span>To proceed please complete the following fields : </span>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (processingCustomConversionAddEditForm.controls['conversion']?.touched ||
                      submitted) &&
                    processingCustomConversionAddEditForm.controls['conversion']?.invalid
                  "
                >
                  Conversion
                </div>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (processingCustomConversionAddEditForm.controls['region']?.touched &&
                      processingCustomConversionAddEditForm.controls['region']?.invalid) ||
                    processingCustomConversionAddEditForm.controls['region'].value?.name ===
                      '--Select region-- ' ||
                    (submitted &&
                      !processingCustomConversionAddEditForm.controls['region'].value?.name)
                  "
                >
                  Region
                </div>
              </div>
              <div class="topBottomCss" *ngIf="processingCustomConversionForm.invalid">
                <div>Default value</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
